module.exports = __webpack_public_path__ + "img/banner-2-5.210661ef.png";